<template>
  <input
    :class="DS_NUMBER_FIELD_CLASSES.HiddenInput"
    data-cy="ds-number-field__hidden-input"
    type="hidden"
    :name="props.name"
    :value="props.value"
    :disabled="props.disabled"
  />
</template>

<script setup lang="ts">
import { DS_NUMBER_FIELD_CLASSES } from "@/src/design_system/form_elements/number_field/constants/classes";

const props = defineProps<{
  name: string;
  value: string | number;
  disabled?: boolean;
}>();
</script>
